"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WikidotTetherResult = void 0;
const react_1 = __importStar(require("react"));
const context_1 = require("../../shared/context");
const sdk_1 = require("../sdk");
var WikidotTetheringState;
(function (WikidotTetheringState) {
    WikidotTetheringState[WikidotTetheringState["Idle"] = 0] = "Idle";
    WikidotTetheringState[WikidotTetheringState["Loading"] = 1] = "Loading";
    WikidotTetheringState[WikidotTetheringState["Complete"] = 2] = "Complete";
    WikidotTetheringState[WikidotTetheringState["Failed"] = 3] = "Failed";
    WikidotTetheringState[WikidotTetheringState["Unauthorized"] = 4] = "Unauthorized";
})(WikidotTetheringState || (WikidotTetheringState = {}));
var WikidotTetherResult;
(function (WikidotTetherResult) {
    WikidotTetherResult["PageNotFound"] = "PageNotFound";
    WikidotTetherResult["WikidotUserAlreadyTethered"] = "WikidotUserAlreadyTethered";
    WikidotTetherResult["Ok"] = "Ok";
})(WikidotTetherResult = exports.WikidotTetherResult || (exports.WikidotTetherResult = {}));
function renderActionBlock(user, state, errorText, onInitClick) {
    switch (state) {
        case WikidotTetheringState.Failed:
            return react_1.default.createElement("div", { className: "wikidot-tethering__error" }, errorText);
        case WikidotTetheringState.Loading:
            return react_1.default.createElement("div", { className: "wikidot-tethering__loading" }, "Loading");
        case WikidotTetheringState.Unauthorized:
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("a", { href: "/auth/google?returnPath=%2Fwikidot%2Ftethering", className: "wikidot-tethering__button" }, "Sign in with Google")));
        case WikidotTetheringState.Complete:
            return (react_1.default.createElement("div", { className: "wikidot-tethering__success" },
                "This account was successfully connected to the Wikidot user ",
                user && user.username));
        case WikidotTetheringState.Idle:
            break;
    }
    return (react_1.default.createElement("div", { className: "wikidot-tethering__instructions" },
        react_1.default.createElement("div", { className: "wikidot-tethering__howto" },
            react_1.default.createElement("ol", null,
                react_1.default.createElement("li", null,
                    "Navigate to the\u00A0",
                    react_1.default.createElement("a", { className: "wikidot-tethering__link", href: `http://wikidot-migration.scpfoundation.net/scp-id-${user && user.id}`, target: "_blank", rel: "noopener noreferrer" }, "migration wiki"),
                    "\u00A0and create an empty page with specified name"),
                react_1.default.createElement("li", null, "Return to this page and press the button below"))),
        react_1.default.createElement("a", { href: "#", onClick: onInitClick, className: "wikidot-tethering__button" }, "Connect your account")));
}
const WikidotTethering = () => {
    const ctx = react_1.useContext(context_1.AppContext);
    const { user } = ctx;
    let initialState;
    if (!user) {
        initialState = WikidotTetheringState.Unauthorized;
    }
    else if (user.wikidotUid) {
        initialState = WikidotTetheringState.Complete;
    }
    else {
        initialState = WikidotTetheringState.Idle;
    }
    const [state, setState] = react_1.useState(initialState);
    const [errorText, setErrorText] = react_1.useState('');
    function initTethering() {
        return __awaiter(this, void 0, void 0, function* () {
            setState(WikidotTetheringState.Loading);
            let result;
            try {
                result = yield sdk_1.sdk.tetherWikidotAccount();
            }
            catch (error) {
                console.error('Failed to tether account', error);
                setState(WikidotTetheringState.Failed);
                setErrorText('Failed to connect account. Reload the page and try again.');
            }
            switch (result) {
                case WikidotTetherResult.PageNotFound:
                    setState(WikidotTetheringState.Failed);
                    setErrorText('Cannot find created page on the migration wiki. Reload and proceed with instructions.');
                    break;
                case WikidotTetherResult.WikidotUserAlreadyTethered:
                    setState(WikidotTetheringState.Failed);
                    setErrorText('This wikidot account already was connected to another user.');
                    break;
                case WikidotTetherResult.Ok:
                    window.location.reload();
                    break;
                default:
                    setState(WikidotTetheringState.Failed);
                    setErrorText('Unknown response status. Please contact developers.');
                    break;
            }
        });
    }
    return (react_1.default.createElement("div", { className: "wikidot-tethering" },
        react_1.default.createElement("div", { className: "wikidot-tethering__content" },
            react_1.default.createElement("div", { className: "wikidot-tethering__title" }, "Wikidot Account Tethering"),
            react_1.default.createElement("div", { className: "wikidot-tethering__welcome" },
                "This page allows you to tether your Wikidot Account to the account on this site.",
                react_1.default.createElement("br", null),
                "In order to do that we'll ask you to create a page with special name that corresponds to your uniq account identificator.",
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("br", null),
                react_1.default.createElement("div", { className: "wikidot-tethering__action-block" }, renderActionBlock(user, state, errorText, initTethering))))));
};
exports.default = WikidotTethering;
//# sourceMappingURL=WikidotTethering.js.map